<template>
  <div id="app">
    <nav class="flex items-center justify-between flex-wrap bg-grey-light px-4">
      <div class="flex items-center flex-no-shrink">
        <router-link to="/" class="py-4 no-underline font-semibold text-xl text-black tracking-tight">Dienste</router-link>
      </div>
      <div class="float-right">
          <div v-if="user">
            <img class="h-6 align-text-bottom" :src="user.photo"/>
            <span class="p-2">{{ user.name || user.email }}</span>
            <button @click="logout" tag="button" class="bg-teal-dark hover:bg-teal text-white py-2 p-2 rounded">&#215;</button>
          </div>
          <div v-if="!user">
            <router-link to="/login" tag="button" class="bg-teal-dark hover:bg-teal text-white py-2 px-2 rounded">Anmelden</router-link>
            <router-link to="/sign-up" tag="button" class="bg-teal-dark hover:bg-teal text-white py-2 px-2 rounded">Registrieren</router-link>
          </div>
        </div>
    </nav>
    <router-view/>
  </div>
</template>

<script>
  import '@/assets/main.css'
  export default {
    name: 'app',
    data () {
      return {
        user: this.$root.$data.user
      }
    },
    methods: {
      logout: function () {
        this.user = null
        this.$root.$data.firebase.app.auth().signOut().then(() => {
          this.$router.push({
            name: 'login'
          })
        })
      }
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue